<template>

<div>

	<div class="head" :class="{'has-scrolled': scrolled && !hasSticky}">

		<div class="head-title"><slot></slot></div>

	</div>

	<div class="head nopadding" v-if="game">

		<div class="head-game" :style="{backgroundImage: gameAvatar}"></div>

	</div>

</div>

</template>

<script>

export default {

	props: ['game', 'scrolled', 'hasSticky'],

	computed: {

		gameAvatar: function() {

			return 'url(' + this.$util.thumbnail.game.generate(this.game, 'large') + ')'

		}

	}

}

</script>

<style scoped>

.head {
	z-index: 2;
	flex-shrink: 0;
	height: 64px;
	display: flex;
	align-items: center;
	padding: 20px;
    background-color: #19455c;
}

.is-mobile .head.has-scrolled,
.modal-wrapper.is-large .head.has-scrolled {
	box-shadow: rgba(9, 30, 66, 0.15) 0px 8px 8px -2px;
}

.is-mobile .head {
    background-color: #fff;
}

.modal-wrapper.is-large .head {
	background-color: #fff;
}

.is-smaller .head {
	height: 64px;
}

.is-mobile .head {
	height: 48px;
	padding: 0px 10px;
}

.modal-wrapper.is-large .head:after {
	display: none;
}

.head.nopadding {
	padding: 0px;
	z-index: 1;
	height: auto;
	flex-direction: column;
}

.head-title {
	text-align: left;
	font-size: 20px;
	color: #fff;
	font-weight: 500;
	line-height: 24px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.head-title >>> small {
	font-size: 14px;
	font-weight: 400;
	line-height: 16px;
	opacity: 0.5;
}

.is-mobile .head-title >>> small {
	font-size: 14px;
	margin-top: -4px;
	line-height: 14px;
}

.is-mobile .head-title {
	color: #343434;
    font-family: 'Barlow', sans-serif;
    letter-spacing: 1px;
    font-weight: 700;
    font-size: 16px;
}

.modal-wrapper.is-large .head-title {
	color: #333;
}

.head.nopadding .head-title {
	padding: 10px 20px;
	width: 100%;
}

.is-mobile .head-title {
	padding-right: 64px;
	color: #343434;
	font-size: 16px;
}

.head-game {
	width: 100%;
	height: 160px;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	flex-shrink: 0;
	border-bottom: 5px solid transparent;
}

</style>